import React, { useEffect, useContext } from 'react';
import { number, array, func } from 'prop-types';
import classNames from 'classnames/bind';

import LinkedVehicleItem from './components/LinkedVehicleItem';
import { usePrevious } from 'hooks/usePrevious';

import { StaticTextContext } from 'context/StaticTextContext';

import { withArticleLinkedAllLinking } from 'containers/withArticleLinkedAllLinking';
import { withAssignedArticlesByIds } from 'containers/withAssignedArticlesByIds';

import styles from './LinkedArticlesTable.module.scss';
const cx = classNames.bind(styles);

const LinkedArticlesTable = ({
  carsData,
  manuLinkedId,
  getArticlesIDs,
  getLinkedArticles,
}) => {
  const { labels } = useContext(StaticTextContext);
  const prevManuLinkedId = usePrevious(manuLinkedId);

  useEffect(() => {
    if (prevManuLinkedId !== manuLinkedId && prevManuLinkedId !== undefined) {
      getLinkedArticles(getArticlesIDs);
    }
  }, [manuLinkedId]);

  return (
    <div className={cx('root')}>
      <table className={cx('cars-table')}>
        <thead>
          <tr>
            <th>
              <div>{labels.linkedVehiclesModelsLabel}</div>
              <div className={cx('mobile-title', 'engine-code')}>
                {labels.linkedVehiclesEngineCodeLabel}
              </div>
            </th>
            <th>
              <div>{labels.linkedVehiclesEngineCodeLabel}</div>
            </th>
            <th>
              <div>{labels.linkedVehiclesModelYearLabel}</div>
            </th>
            <th>
              <div className={cx('mobile-title', 'model-year')}>
                {labels.linkedVehiclesModelYearLabel}
              </div>
              <div>{labels.linkedVehiclesKwHpLabel}</div>
            </th>
          </tr>
        </thead>

        <tbody>
          {carsData.map((item, index) => (
            <LinkedVehicleItem key={index} data={item} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

LinkedArticlesTable.propTypes = {
  manuLinkedId: number.isRequired,
  carsData: array.isRequired,
  getLinkedArticles: func.isRequired,
  getArticlesIDs: func.isRequired,
};

export default withArticleLinkedAllLinking(
  withAssignedArticlesByIds(LinkedArticlesTable)
);



// WEBPACK FOOTER //
// ./src/pages/Product/components/LinkedArticlesTable/LinkedArticlesTable.js